import { useState } from "react";
import { Button } from "@mui/material";
import { syncWb } from "../../utils/syncClient";
import { useSnackbar } from "notistack";
import { COLORS } from "../../utils/colors";

export default function WbSyncButton({ setReloadToken }) {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  return (
    <Button
      size="small"
      variant="contained"
      sx={{
        bgcolor: COLORS.WB.bgcolor,
        color: COLORS.WB.color,
      }}
      onClick={async () => {
        try {
          setLoading(true);
          await syncWb();
          enqueueSnackbar("Заказы Wildberries обновлены", {
            variant: "success",
          });
          setReloadToken((x) => x + 1);
        } catch (e) {
          console.error("[wb-sync] fail", e);
          enqueueSnackbar("Синхронизация Wildberries не удалась", {
            variant: "error",
          });
        } finally {
          setLoading(false);
        }
      }}
      disabled={loading}
    >
      {loading ? "СИНХРОНИЗАЦИЯ…" : "ОБНОВИТЬ WB"}
    </Button>
  );
}
